export default __webpack_public_path__ + "images/defaultAvatar.c2a85de7c69845724d33bdbd675fdf20.png";